import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const activePasiveVoiceQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "¿Cuál de estas oraciones está en voz pasiva? 'El libro ___  leído por Juan el mes pasado.'",
        options: ["era", "es", "fue", "será"],
        correctAnswerIndex: 2,
        explanation: "'Fue leído' es una construcción pasiva. En la voz activa sería: 'Juan leyó el libro'."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "¿Cuál de estas oraciones está en voz pasiva? 'El informe ___ preparado por el equipo cada mes.'",
        options: ["era", "es", "sería", "será"],
        correctAnswerIndex: 1,
        explanation: "'Es preparado' es una construcción pasiva. En la voz activa sería: 'El equipo prepara el informe cada mes.' El indicador de tiempo 'cada mes' indica una acción habitual, por lo que se usa el presente 'es'."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "Convierte la oración a voz pasiva: 'El carpintero arreglaba las sillas todos los días.'",
        options: [
            "Las sillas eran arregladas por el carpintero todos los días.",
            "Las sillas son arregladas por el carpintero todos los días.",
            "Las sillas serán arregladas por el carpintero todos los días.",
            "Las sillas han sido arregladas por el carpintero todos los días."
        ],
        correctAnswerIndex: 0,
        explanation: "La oración en voz activa 'El carpintero arreglaba las sillas todos los días' se convierte en 'Las sillas eran arregladas por el carpintero todos los días', usando el imperfecto de la voz pasiva."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "¿Cómo se convierte la oración activa en pasiva? 'Ellos comieron la pizza.'",
        options: [
            "La pizza comieron ellos.",
            "La pizza fue comida por ellos.",
            "Ellos fueron la pizza comida.",
            "La pizza será comida por ellos."
        ],
        correctAnswerIndex: 1,
        explanation: "Para convertir la oración activa en pasiva, se invierte el sujeto y el objeto. La respuesta correcta es 'La pizza fue comida por ellos'."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "¿Cuál de estas oraciones está en voz pasiva? 'La película ___ dirigida por un director famoso el próximo año.'",
        options: ["será", "es", "fue", "era"],
        correctAnswerIndex: 0,
        explanation: "'Será dirigida' es una construcción pasiva. En la voz activa sería: 'Un director famoso dirigirá la película el próximo año.' El tiempo futuro 'el próximo año' indica que la acción sucederá en el futuro, por lo que se usa 'será'."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "¿Cuál de estas oraciones está en voz pasiva? 'El proyecto ___ siendo revisado por el jefe esta semana.'",
        options: ["es", "está", "será", "fue"],
        correctAnswerIndex: 1,
        explanation: "'Está siendo revisado' es una construcción pasiva. En la voz activa sería: 'El jefe está revisando el proyecto esta semana.' El tiempo 'esta semana' indica una acción que ocurre en el presente, por lo que se usa 'está'."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "¿Cuál es la forma correcta en voz pasiva? 'La película ___ dirigida por un famoso director.(Presente)'",
        options: ["es", "fue", "será", "era"],
        correctAnswerIndex: 0,
        explanation: "En la voz pasiva, usamos 'es dirigida' para indicar una acción que ocurre en el presente."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "Convierte la oración a voz pasiva: 'Juan escribió la carta ayer.'",
        options: [
            "La carta fue escrita por Juan ayer.",
            "La carta es escrita por Juan ayer.",
            "La carta ha sido escrita por Juan ayer.",
            "La carta será escrita por Juan ayer."
        ],
        correctAnswerIndex: 0,
        explanation: "La oración en voz activa 'Juan escribió la carta ayer' se convierte en 'La carta fue escrita por Juan ayer', usando el pretérito de la voz pasiva."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "Convierte la oración a voz pasiva: 'El chef prepara la comida todos los días.'",
        options: [
            "La comida será preparada por el chef todos los días.",
            "La comida fue preparada por el chef todos los días.",
            "La comida es preparada por el chef todos los días.",
            "La comida ha sido preparada por el chef todos los días."
        ],
        correctAnswerIndex: 2,
        explanation: "La oración en voz activa 'El chef prepara la comida todos los días' se convierte en 'La comida es preparada por el chef todos los días', usando el presente de la voz pasiva."
    },
    {
        category: QuizCategory.VOZ_ACTIVA_PASIVA,
        questionText: "Convierte la oración a voz pasiva: 'El director habría firmado los documentos si hubiera estado presente.'",
        options: [
            "Los documentos habrían sido firmados por el director si hubiera estado presente.",
            "Los documentos serían firmados por el director si hubiera estado presente.",
            "Los documentos son firmados por el director si hubiera estado presente.",
            "Los documentos fueron firmados por el director si hubiera estado presente."
        ],
        correctAnswerIndex: 0,
        explanation: "La oración en voz activa 'El director habría firmado los documentos si hubiera estado presente' se convierte en 'Los documentos habrían sido firmados por el director si hubiera estado presente', usando el condicional perfecto de la voz pasiva."
    }
];

export default activePasiveVoiceQuestions;